import AssociatedContactSelectorContainer from './containers/AssociatedContactSelectorContainer'

export default AssociatedContactSelectorContainer
